import React, { useState } from "react";
import { Input, Button, Typography, Form, message, Card, Row, Col } from "antd";
import { LockOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import authService from "../networks/api/service/authService";
import PrimaryButton from "./TableComponent/ButtonComponent/Buttons";

const { Title, Text } = Typography;

function VerifyOTP() {
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();

  // Handle OTP input change
  const handleOtpChange = (e) => {
    const value = e.target.value;
    // Allow only numbers and limit input to 6 digits
    if (/^\d{0,6}$/.test(value)) {
      setOtp(value);
    }
  };

  // Handle OTP submission
  const handleSubmit = async () => {
    if (otp.length === 6) {
      message.success(`OTP submitted: ${otp}`);
      // Reset OTP after submission (optional)
      const data = {
        otp: otp,
        phoneNo: localStorage.getItem("phoneNo"),
      };
      const res = await authService.VerifyOtp(data);

      if (res.code == 200) {
        localStorage.setItem("JWTtoken", res.data.token);
        localStorage.setItem("UserRole", res.data.role);
        // localStorage.setItem("UserRole", "CONSTITUENCY");

        if (res.data.role === "ADMIN") {
          navigate("/login/constituency");
        }else if (res.data.role === "GRIEVANCEADMIN"){
          navigate("/login/grievance")
        } else {
          navigate("/login/dashboard");
        }
      }

      setOtp("");
    } else {
      message.error("Please enter a valid 6-digit OTP");
    }
  };

  return (
    <div style={styles.pageContainer}>
      <Row justify="center" align="middle" style={{ minHeight: "100vh" }}>
        <Col xs={24} sm={16} md={8} lg={6}>
          <Card bordered style={styles.cardStyle}>
            <div style={styles.iconWrapper}>
              <LockOutlined style={styles.icon} />
            </div>
            <Title level={3} style={styles.title}>
              Verify OTP
            </Title>
            <Text type="secondary">
              Please enter the 6-digit OTP sent to your phone
            </Text>

            <Form onFinish={handleSubmit} style={styles.form}>
              <Form.Item
                validateStatus={
                  otp.length !== 6 && otp.length > 0 ? "error" : ""
                }
                help={
                  otp.length !== 6 && otp.length > 0
                    ? "Enter exactly 6 digits"
                    : ""
                }
              >
                <Input
                  placeholder="Enter OTP"
                  value={otp}
                  onChange={handleOtpChange}
                  maxLength={6}
                  style={styles.otpInput}
                  size="large"
                />
              </Form.Item>

              <PrimaryButton
                htmlType="submit"
                disabled={otp.length !== 6}
                style={styles.submitButton}
                block
              >
                Submit OTP
              </PrimaryButton>
            </Form>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

// Inline styles for better UI
const styles = {
  pageContainer: {
    background: "#f0f2f5",
    padding: "20px",
    height: "100vh",
  },
  cardStyle: {
    textAlign: "center",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    borderRadius: "8px",
    padding: "30px",
  },
  iconWrapper: {
    textAlign: "center",
    marginBottom: "20px",
  },
  icon: {
    fontSize: "40px",
    color: "#0b023d",
  },
  title: {
    marginBottom: "10px",
    color: "#0b023d",
  },
  form: {
    marginTop: "20px",
  },
  otpInput: {
    textAlign: "center",
    fontSize: "18px",
  },
  submitButton: {
    marginTop: "15px",
  },
};

export default VerifyOTP;
